import React from 'react';

import browseHomeIcon from './assets/browseHome.png';
import myListingsIcon from './assets/myListings.png';
import communityIcon from './assets/community.png';
import transactionsIcon from './assets/transactions.png';
import watchedListingsIcon from './assets/watchedListings.png';
import profileIcon from './assets/profile.png';
import accountSettingsIcon from './assets/accountSettings.png';
import messagesIcon from './assets/messages.png';
import directoryIcon from './assets/directory.png';

/**
 * Tab + drawer icons. Tab glyphs use provided PNG assets tinted via CSS mask + currentColor.
 */

/** Bottom-bar tab icons: base was 23px; +50% → 35. Community (tags) is denser → +75% → 40. */
const TAB_ICON_SIZE = 35;
const COMMUNITY_TAB_ICON_SIZE = 40;

const maskIconStyle = (src, size = TAB_ICON_SIZE) => ({
  display: 'block',
  width: size,
  height: size,
  backgroundColor: 'currentColor',
  WebkitMaskImage: `url(${src})`,
  maskImage: `url(${src})`,
  WebkitMaskSize: 'contain',
  maskSize: 'contain',
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  maskPosition: 'center',
});

/** Browse — custom home glyph */
export const BrowseIcon = () => <span aria-hidden style={maskIconStyle(browseHomeIcon)} />;

/** My Listings — custom fish glyph */
export const ListingsIcon = () => <span aria-hidden style={maskIconStyle(myListingsIcon)} />;

/**
 * Receipt with a check — Your transactions.
 *
 * @param {Object} props
 * @param {number} [props.size] Defaults to the bottom-bar tab size.
 */
export const TransactionsIcon = ({ size = TAB_ICON_SIZE }) => (
  <span aria-hidden style={maskIconStyle(transactionsIcon, size)} />
);

/** Community — price-tag glyph (drawn smaller in asset; sized up further) */
export const CommunityIcon = () => (
  <span aria-hidden style={maskIconStyle(communityIcon, COMMUNITY_TAB_ICON_SIZE)} />
);

/**
 * Envelope — forum DMs. PNG mask tinted via currentColor (topbar / bottom nav / drawer).
 *
 * @param {Object} props
 * @param {number} [props.size]
 */
export const EnvelopeIcon = ({ size = 24 }) => (
  <span aria-hidden style={maskIconStyle(messagesIcon, size)} />
);

/** Centre FAB plus — white stroke per prototype */
export const PlusIcon = () => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fff"
    strokeWidth={2.4}
    strokeLinecap="round"
    aria-hidden
    focusable={false}
  >
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </svg>
);

/** Drawer row icons (18px). */
export const DrawerHomeIcon = () => <span aria-hidden style={maskIconStyle(browseHomeIcon, 18)} />;

export const DrawerListingsIcon = () => (
  <span aria-hidden style={maskIconStyle(myListingsIcon, 18)} />
);

export const DrawerWatchedIcon = () => (
  <span aria-hidden style={maskIconStyle(watchedListingsIcon, 18)} />
);

export const DrawerTransactionsIcon = () => <TransactionsIcon size={18} />;

export const DrawerProfileSettingsIcon = () => (
  <span aria-hidden style={maskIconStyle(profileIcon, 18)} />
);

export const DrawerAccountSettingsIcon = () => (
  <span aria-hidden style={maskIconStyle(accountSettingsIcon, 18)} />
);

/** Drawer — address book (Directory). Slightly larger so the person-in-book reads at drawer size. */
export const DrawerDirectoryIcon = () => (
  <span aria-hidden style={maskIconStyle(directoryIcon, 22)} />
);
